// extracted by mini-css-extract-plugin
export var actionButton = "_f2-0";
export var attachmentLine = "_f2-1";
export var fileInput = "_f2-2";
export var fileUploadWrapper = "_f2-4";
export var footer = "_f2-3";
export var modalContent = "_f2-5";
export var paperclip = "_f2-6";
export var quillEditor = "_f2-7";